import { render, staticRenderFns } from "./AddBastion.vue?vue&type=template&id=d944e08c"
import script from "./AddBastion.vue?vue&type=script&lang=js"
export * from "./AddBastion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports